import { useMemo, useState } from "react";

import { QuoteRequestLineDto } from "#modules/quoteRequestLines/infra/fetchQuoteRequestLine.api";
import {
  AssemblyWithChildren,
  SortConfig,
  SortOrder,
  SortProperty,
  sortQuoteRequestLines,
} from "shared";

export type { SortOrder, SortProperty };

export const useQuoteRequestLinesSorting = (
  quoteRequestLines: QuoteRequestLineDto[],
): {
  batches: Map<string, AssemblyWithChildren<QuoteRequestLineDto>[]>;
  assemblies: AssemblyWithChildren<QuoteRequestLineDto>[];
  handleSort: (property: SortProperty, order?: SortOrder) => void;
  sortProperty: SortProperty;
} => {
  const [sortConfig, setSortConfig] = useState<SortConfig>({
    property: "index",
    order: "asc",
  });

  const { batches, assemblies } = useMemo(
    () => sortQuoteRequestLines(quoteRequestLines, sortConfig),
    [quoteRequestLines, sortConfig],
  );

  const handleSort = (property: SortProperty, order: SortOrder = "asc") => {
    setSortConfig({ property, order });
  };

  return {
    batches,
    assemblies,
    handleSort,
    sortProperty: sortConfig.property,
  };
};
